const TrashIcon = ({
  width = 24,
  height = 24,
  size,
  fill = '#CE181E',
}: {
  width?: number;
  height?: number;
  size?: number;
  fill?: string;
}) => {
  const iconWidth = size || width;
  const iconHeight = size || height;

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.625 17.8125C15.0391 17.8125 15.375 17.4767 15.375 17.0625V9.5625C15.375 9.14835 15.0391 8.8125 14.625 8.8125C14.2109 8.8125 13.875 9.14835 13.875 9.5625V17.0625C13.875 17.4767 14.2109 17.8125 14.625 17.8125Z"
        fill={fill}
      />
      <path
        d="M9.375 17.8125C9.78915 17.8125 10.125 17.4767 10.125 17.0625V9.5625C10.125 9.14835 9.78915 8.8125 9.375 8.8125C8.96085 8.8125 8.625 9.14835 8.625 9.5625V17.0625C8.625 17.4767 8.96085 17.8125 9.375 17.8125Z"
        fill={fill}
      />
      <path
        d="M15 3.1875C15.4142 3.1875 15.75 2.85165 15.75 2.4375C15.75 2.02335 15.4142 1.6875 15 1.6875H9C8.58585 1.6875 8.25 2.02335 8.25 2.4375C8.25 2.85165 8.58585 3.1875 9 3.1875H15Z"
        fill={fill}
      />
      <path
        d="M3.75 3.9375C3.33585 3.9375 3 4.27335 3 4.6875C3 5.10165 3.33585 5.4375 3.75 5.4375H4.5V19.2375C4.5 20.9324 5.88 22.3125 7.575 22.3125H16.425C18.1199 22.3125 19.5 20.9325 19.5 19.2375V5.4375H20.25C20.6642 5.4375 21 5.10165 21 4.6875C21 4.27335 20.6642 3.9375 20.25 3.9375H18.75H5.25H3.75ZM18 5.4375V19.2375C18 20.1075 17.295 20.8125 16.425 20.8125H7.575C6.705 20.8125 6 20.1075 6 19.2375V5.4375H18Z"
        fill={fill}
      />
    </svg>
  );
};

export { TrashIcon };
